<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="`Delete Course -- ${courseId}`"
    :reset-modal="resetModal"
    :submit-button-text="'DELETE'"
    :submit-modal="deleteCourse"
    :submit-error="deleteCourseError"
    :submit-error-text="`An error occurred deleting ${courseId}`"
  >
    <b-row
      ><b-col>
        <p class="tsny_text">
          This action will delete the {{ courseId }} course. Please be
          absolutely certain you want to do this -- this action cannot be
          undone.
        </p>
      </b-col></b-row
    >
    <b-row>
      <b-col
        ><p class="tsny_status-text" v-if="deleteCourseError">
          An error occurred deleting {{ courseId }}
        </p></b-col
      >
    </b-row>
  </tsny-modal>
</template>

<script>
import CourseRestService from "../../services/rest/services/CourseRestService";
import TsnyModal from "../TsnyModal";

export default {
  name: "DeleteCourseModal",
  components: { TsnyModal },
  props: {
    courseId: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      modalId: "deleteCourseModal",
      deleteCourseError: null
    };
  },
  methods: {
    deleteCourse: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this;
      $comp.deleteCourseError = false;

      return CourseRestService.deleteCourse($comp.courseId)
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          $comp.deleteCourseError = true;
          console.log(err);
        });
    },
    resetModal: function() {
      this.deleteCourseError = null;
    }
  }
};
</script>

<style scoped></style>
